<template>
  <div>
    <VueApexCharts
      :key="chartkey"
      type="area"
      height="350"
      :options="chartOptions"
      :series="series"
    ></VueApexCharts>
  </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'
import moment from 'moment'
export default {
  props: ['data'],
  components: {
    VueApexCharts
  },
  data() {
    return {
      chartkey: 0,
      series: [
        {
          name: 'Ticket',
          data: []
        }
      ],
      chartOptions: {
        colors: ['#FF706B'],

        chart: {
          height: 350,
          type: 'area'
        },
        dataLabels: {
          enabled: false
        },
        stroke: {
          curve: 'smooth'
        },
        xaxis: {
          type: 'datetime',
          categories: []
        },
        tooltip: {
          x: {
            format: 'dd/MM/yy HH:mm'
          }
        }
      }
    }
  },
  mounted() {
    if (this.data) {
      // var memberdata = this.data
      //   .map((el) => moment(el).format('YYYY-MM-DD'))
      //   .sort(function (a, b) {
      //     a = a.split('-').join('')
      //     b = b.split('-').join('')
      //     return a > b ? 1 : a < b ? -1 : 0
      //   })
      // var counts = {}
      // memberdata.forEach(function (x) {
      //   counts[x] = (counts[x] || 0) + 1
      // })
      // var series = []
      // for (const item in counts) {
      //   series.push({ x: item, y: counts[item] })
      // }

      var series = this.data.map((el) => {
        let newTimestamp = moment(el.timestamp).add(7, 'hours').toISOString()
        return { x: newTimestamp, y: parseFloat(el.total) }
      })
      this.series[0].data = series
      this.chartkey++
    }
  },
  computed: {}
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/toa/agentmanagement/OverviewTicketChart.vue